import { useTeam } from "@teamna/web-client/hooks/use-setup.ts";

/**
 * The profile photo of a team member, for the coach's face next to the coach's name on any owner
 * page (2026-10-21). Read from the team list (`useTeam`), which most owner pages already load, so
 * no route has to carry photos. By user id first; by the exact name for a row that has only the
 * name (the Home sessions). Null draws the initials.
 */
export function useStaffPhotos(businessId: string | null): (userId: string | null | undefined, name?: string | null) => string | null {
  const team = useTeam(businessId);
  return (userId, name) => {
    const rows = team.data ?? [];
    const member = (userId ? rows.find((row) => row.userId === userId) : undefined) ?? (name ? rows.find((row) => row.name === name) : undefined);
    return member?.photoUrl ?? null;
  };
}
